import React from 'react'

import { UPLOAD_ERRORS } from './constants'
import {
  S_UploadResults,
  S_SucessfullUploads,
  S_UploadErrorsContainer,
  S_ErrorsTitle,
  S_ErrorRow,
  S_ErrorRowNumber,
  S_ErrorColumns,
  S_ErrorColumnName,
  S_ErrorColumnDescription,
  S_ErrorColumnItem,
  S_UploadWarningsContainer,
  S_UploadWarningsList,
  S_WarningsTitle,
  S_WarningRow,
  S_WarningRowNumber,
  S_WarningColumns,
  S_WarningColumnName,
  S_WarningColumnDescription,
  S_WarningColumnItem,
} from './UploadResults.styles.js'

export const UploadResults = (props) => {
  const { successCount, errors, warnings, templateError } = props

  return (
    <S_UploadResults>
      <h1>Upload Summary</h1>
      {successCount > 0 && (
        <S_SucessfullUploads>
          Successfully created {successCount} new {successCount > 1 ? 'invoices' : 'invoice'}.
        </S_SucessfullUploads>
      )}

      {errors.length > 0 && (
        <S_ErrorsTitle>
          Errors ({errors.length} {errors.length > 1 ? 'rows' : 'row'})
        </S_ErrorsTitle>
      )}
      {errors.length > 0 && (
        <S_UploadErrorsContainer>
          {errors.map((error, errorIndex) => {
            return (
              <S_ErrorRow key={`invoice-upload-error-${errorIndex}`}>
                <S_ErrorRowNumber>Row #{error.row}</S_ErrorRowNumber>
                <S_ErrorColumns>
                  {error.columns.map((column, columnIndex) => {
                    return (
                      <S_ErrorColumnItem key={`invoice-upload-error-column-${columnIndex}`}>
                        <S_ErrorColumnName>{column.name}</S_ErrorColumnName>
                        <S_ErrorColumnDescription>{`${UPLOAD_ERRORS[column.error_code]}`}</S_ErrorColumnDescription>
                      </S_ErrorColumnItem>
                    )
                  })}
                </S_ErrorColumns>
              </S_ErrorRow>
            )
          })}
        </S_UploadErrorsContainer>
      )}

      {templateError && (
        <S_UploadErrorsContainer>
          The template is not formatted correctly. Please check the column names are correct.
        </S_UploadErrorsContainer>
      )}

      {warnings.length > 0 && (
        <S_WarningsTitle>
          Warnings ({warnings.length} {warnings.length > 1 ? 'rows' : 'row'})
        </S_WarningsTitle>
      )}
      {warnings.length > 0 && (
        <S_UploadWarningsContainer>
          <S_UploadWarningsList>
            {warnings.map((warning, warningIndex) => {
              return (
                <S_WarningRow key={`invoice-upload-warning-${warningIndex}`}>
                  <S_WarningRowNumber>Row #{warning.row}</S_WarningRowNumber>
                  <S_WarningColumns>
                    {warning.columns.map((column, columnIndex) => {
                      return (
                        <S_WarningColumnItem key={`invoice-upload-warning-column-${columnIndex}`}>
                          <S_WarningColumnName>{column.name}</S_WarningColumnName>
                          <S_WarningColumnDescription>{`${
                            UPLOAD_ERRORS[column.error_code]
                          }`}</S_WarningColumnDescription>
                        </S_WarningColumnItem>
                      )
                    })}
                  </S_WarningColumns>
                </S_WarningRow>
              )
            })}
          </S_UploadWarningsList>
        </S_UploadWarningsContainer>
      )}
    </S_UploadResults>
  )
}
